import { TaskShareModalComponent } from './../modules/tasks/components/task-share-modal/task-share-modal.component';
import { Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Task } from '@shared/models/task.model';
import { AppInjector } from '@shared/services/app-injector.service';
import { TaskService } from '@shared/modules/tasks/services/task-service';
import { Config } from '@shared/configs/config';

export class TaskController {
  injector: Injector;
  dialog: MatDialog;
  taskService: TaskService;

  constructor(public task: Task) {
    this.injector = AppInjector.getInjector();
    this.dialog = this.injector.get(MatDialog);
    this.taskService = this.injector.get(TaskService);
  }

  updateTask(task: Task) {
    (task as any).dataChanges = 1;
    return this.taskService.editTask(task, task.id);
  }

  changeTaskStatus(task: Task, isMyWork?: boolean) {
    return this.taskService.editStatus(
      { status: task.status, hiddenForClient: task.hiddenForClient, isMyWork },
      task.id
    );
  }

  completeSubtasks(task: Task) {
    return this.taskService.finishTask(task.id, 1);
  }

  assignToTask(task: Task, assignToIds: number[], assignedEmail?: string[]) {
    return this.taskService.groupAssign([task.id], assignToIds, assignedEmail);
  }

  removeTask(task: Task) {
    return this.taskService.deleteTask(task.id);
  }

  askForShare(task: Task) {
    return this.dialog
      .open(TaskShareModalComponent, {
        width: Config.DEFAULT_MODAL_WIDTH,
        autoFocus: false,
        data: { task }
      })
      .afterClosed()
      .toPromise()
      .then((res) => {
        return new Promise((resolve, reject) => {
          if (!!res?.accepted) {
            resolve(res);
          }
          reject();
        });
      });
  }
}
